export const VARIANT = {
	DETERMINATE: 0,
	INDETERMINATE: 1
};
